export const STINK = {
  id: 42069,
  height: 5449315,
  data: {
    icon: "/imgs/icons/asset/stink.webp",
  },
};
